/* SPH – Lieferzeit-Text global auf „3 – 8 Werktage“ */
(function () {
  var RE = /3\s*[–—-]\s*5\s*Werktage/g;
  function fix(node) {
    var w = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null);
    var t;
    while ((t = w.nextNode())) {
      if (RE.test(t.nodeValue)) t.nodeValue = t.nodeValue.replace(RE, '3 – 8 Werktage');
      RE.lastIndex = 0;
    }
  }
  function boot() {
    fix(document.body);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) fix(n);
          else if (n.nodeType === 3 && RE.test(n.nodeValue)) { n.nodeValue = n.nodeValue.replace(RE, '3 – 8 Werktage'); RE.lastIndex = 0; }
        });
        if (m.type === 'characterData' && RE.test(m.target.nodeValue)) { m.target.nodeValue = m.target.nodeValue.replace(RE, '3 – 8 Werktage'); RE.lastIndex = 0; }
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
